import * as React from "react"
import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[88px] w-full rounded-md border border-border bg-card px-4 py-3 text-base leading-relaxed text-foreground shadow-[0_1px_1px_rgb(0_0_0/0.02)] transition-[color,box-shadow,border-color] placeholder:text-muted-foreground hover:border-border focus:outline-none focus-visible:border-primary/60 focus-visible:ring-4 focus-visible:ring-primary/12 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }